export default __webpack_public_path__ + "static/media/laser.c2734687.png";